import { SxProps, Theme } from "@mui/material";

export const modalBodyStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "20px",
};

export const cardStyle = {
  width: 180,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "primary.main",
  cursor: "pointer",
  transition: "background-color 0.3s, color 0.3s",
  "&:hover": {
    backgroundColor: "rgba(109, 135, 170, 0.1)",
  },
};

export const dialogCont = {
  width: "1300px",
  height: "550px",
  borderRadius: "16px",
};

export const dialogBox = {
  position: "relative",
  width: "100%",
  height: "70%",
  borderBottomLeftRadius: 6,
  borderBottomRightRadius: 6,
  overflow: "hidden",
};

export const dialogContentBox = {
  mt: 2,
  paddingLeft: 10,
  paddingRight: 10,
  paddingTop: 3,
};

export const dialogSlider = {
  height: 12,
  "& .MuiSlider-track": {
    backgroundColor: "#FF5F47",
    border: "red",
  },
  "& .MuiSlider-thumb": {
    backgroundColor: "#FF5F47",
  },
  "& .MuiSlider-rail": {
    backgroundColor: "#d0d0d0",
  },
};

export const dialogBoxButtons = {
  display: "flex",
  justifyContent: "flex-end",
  mt: 2,
  paddingRight: 5,
};

export const dialogSaveButton = {
  ml: 2,
  borderRadius: "9999px",
  px: 3,
  py: 0,
};

export const dialogBoxImage = {
  height: "120px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
};

export const dialogBoxImagePlaceholder = {
  width: "120px",
  height: "120px",
  borderRadius: "50%",
  backgroundColor: "#B6BFCB",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
};

export const dialogBoxPreviewUrl = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
};

export const dialogBoxAdd = {
  position: "absolute",
  bottom: 0,
  right: 0,
  width: "36px",
  height: "36px",
  borderRadius: "50%",
  backgroundColor: "#FF5F47",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: 1,
  cursor: "pointer",
};

export const dialogAddPhoto = {
  fontSize: 25,
  color: "#fff",
};

export const dialogMainBox = {
  position: "relative",
  width: "120px",
  height: "120px",
};

export const homeCont = {
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  overflowX: "clip",
  px: { xs: 2, md: 4 },
  transition: "margin 0.3s ease",
  paddingTop: { mobile: 2, tablet: 0 },
};

export const announcementsCont = (openModal: boolean): SxProps<Theme> => ({
  mt: "20px",
  width: "100%",
  minWidth: { mobile: 270, tablet: 500, laptop: "100%" },
  height: "auto",
  backgroundColor: "#F1F5FF",
  borderRadius: 2,
  py: 2,
  overflow: "visible",
  maxWidth: openModal ? "50vw" : "100vw",
  mr: "10px",
});

export const imageCont = {
  width: "100%",
  height: "460px",
  backgroundColor: "#F1F5FF",
  borderRadius: 2,
  p: 3,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

export const iamgeTextCont = {
  width: "100%",
  textAlign: "left",
  mt: 0,
  mb: 7,
  ml: { mobile: 5, tablet: 15 },
};

export const leftArrow = {
  position: "absolute",
  top: "50%",
  left: 8,
  transform: "translateY(-50%)",
  zIndex: 10,
  backgroundColor: "white",
  boxShadow: 1,
  color: "#123257",

  "&:hover, &:focus, &.Mui-focusVisible, &:active": {
    backgroundColor: "white !important",
  },
};

export const rightArrow = {
  position: "absolute",
  top: "50%",
  right: 8,
  transform: "translateY(-50%)",
  zIndex: 10,
  backgroundColor: "white",
  boxShadow: 1,
  color: "#123257",
  "&:hover, &:focus, &.Mui-focusVisible, &:active": {
    backgroundColor: "white !important",
  },
};

export const announcementAddCard = {
  maxWidth: { mobile: 265, tablet: 550, laptop: "100%" },
  height: "310px",
  borderRadius: 4,
  boxShadow: 3,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#F0F5FF",
  cursor: "pointer",
  "&:hover": { backgroundColor: "#F0F5FF" },
};

export const addIconBtn = {
  width: 60,
  height: 60,
  borderRadius: "50%",
  mb: 2,
  color: "#FF5F47",
};

export const addBtn = {
  width: 60,
  height: 60,
};

export const announcementCard = {
  maxWidth: { mobile: 265, tablet: 565, laptop: "100%" },
  height: "310px",
  borderRadius: 4,
  boxShadow: 3,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "white",
};

export const mediaCard = {
  width: { mobile: "90%", tablet: "95%" },
  aspectRatio: 3,
  objectFit: "fill",
  borderRadius: 6,
  padding: "10px",
  mx: "auto",
};
export const cardContent = {
  paddingTop: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
};

export const announcementTitle = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  textAlign: "left",
  color: "#123257",
};

export const announcementCont = {
  display: "grid",
  gridTemplateColumns: "1fr auto",
  alignItems: "center",
  width: "100%",
  flexWrap: "nowrap",
};

export const announcementContent = {
  flex: "1 1 0%",
  minWidth: 0,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  fontSize: "12px",
  textAlign: "left",
  pr: 1,

  "& p, & div, & ul, & ol, & li": {
    display: "inline",
    margin: 0,
    padding: 0,
  },
};

export const arrowBtn = {
  p: 0,
  color: "#123257",
  flexShrink: 0,
};

export const emptyCont = {
  borderRadius: "12px",
  height: "308px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "white",
};

export const emptyImageCont = {
  textAlign: "center",
  color: "#6D87AA",
  fontSize: "18px",
  fontWeight: 500,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 1,
};

export const emptyText = {
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: "24px",
  color: "#A1A1A1",
};

export const addText = {
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "20px",
  color: "#6D87AA",
  cursor: "pointer",
};
